export default __webpack_public_path__ + "static/media/projetos.750a586c.png";